import React from "react";
import "./menu-categories.css";
import "../base.css";
import Category from "./Category";
import MenuNotFound from "./MenuNotFound";
import { addDishSpecialType } from "../../utils/helper";

const MenuCategories = (props) => {
  const categoriesList = props.categories?.filter((a)=> a.dishes?.length);
  const updatedCatList = addDishSpecialType(categoriesList)
  return (
    <section style={{ padding: "0px 22px" }} className="section-food-accordian">
      <div className="food-accordian">
        <ul className="collapsible">
          {props.noDishes ? (
            <MenuNotFound
              img="images/Empty State-05.svg"
              header="Unlock Chef Menus."
              description="Browse Chefs and unlock their menu. Get quick access to all their dishes here."
            />
          ) : props.categories?.length > 0 ? (
            updatedCatList.map((category, index) => (
              <Category
                key={index}
                toggleCategory={props.toggleCategory}
                name={category.name}
                cuisine={category.cuisine}
                totalDishes={category.dishes && category.dishes.length}
                dishes={category.dishes}
                saff={props.saff}
                isOpens={category?.isOpen}
                categoryid={category._id}
                category={category}
                onCheckPrice={props.onCheckPrice}
                setShowAddedItemPopup={props.setShowAddedItemPopup}
                parentComponent={props.parentComponent}
                menuId={props.menuIds ? props.menuIds[index] : undefined}
              />
            ))
          ) : (
            <MenuNotFound
              img="images/Empty State-06.svg"
              header="No dishes match your search."
              description="Please check menus of other chefs."
            />
          )}
        </ul>
      </div>
    </section>
  );
};
export default MenuCategories;